<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate">Asociar OOCC</span>
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <form class="form" [formGroup]="formOOCC" autocomplete="off">
            <mat-form-field class="full-width">
                <mat-label>Nro. OOCC </mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="nroOOCC"
                    required
                />

                <mat-error *ngIf="nroOOCC.hasError('required')">
                    Debe ingresar el Nro. de OOCC
                </mat-error>
                <mat-error *ngIf="nroOOCC.hasError('maxlength')">
                    El numero de OOCC no puede tener mas de 20 caracteres
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Rut a facturar</mat-label>
                <input
                    matInput
                    type="text"
                    formControlName="rutFacturar"
                    required
                />
                <mat-hint>Rut con formato 12345678-9</mat-hint>
                <mat-error *ngIf="rutFacturar.hasError('required')">
                    Debe ingresar el rut a facturar
                </mat-error>
                <mat-error *ngIf="rutFacturar.hasError('digitoVerificador')">
                    Debe ingresar un rut válido
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Fecha </mat-label>

                <input
                    matInput
                    [matDatepicker]="fechaOOCC"
                    name="fecha"
                    formControlName="fecha"
                    readonly
                    required
                />
                <mat-datepicker-toggle
                    matSuffix
                    [for]="fechaOOCC"
                ></mat-datepicker-toggle>
                <mat-datepicker #fechaOOCC></mat-datepicker>
                <mat-error *ngIf="fecha.hasError('required')">
                    Debe ingresar la fecha de la OOCC
                </mat-error>
            </mat-form-field>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formOOCC.value"
            [disabled]="!formOOCC.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
